import {
  ChangeDetectorRef,
  Component,
  HostBinding,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { EventEmitter } from '@angular/core';
import { SectionState } from '@shared-features/enums/layout.enum';



@Component({
  selector: 'app-state-section',
  templateUrl: './state-section.component.html',
  styleUrls: ['./state-section.component.scss'],
  // changeDetection: ChangeDetectionStrategy.OnPush
})
export class StateSectionComponent implements OnInit {
  @Input() state: SectionState;
  @Input() loadingLabel: string;
  @Input() errorStateLabel: string;
  @Input() emptyStateMainLabel: string;
  @Input() emptyStateSubLabel: string;
  @Input() emptyStateImagePath: string;
  @Input() emptyStateIcon: string;
  @Input() comingSoonStateLabel: string;
  @Input() comingSoonStateImagePath: string;
  /** Set false where the host already offers a way to clear the search. */
  @Input() showClearButton = true;

  @Input() isPageSection = false;
  @Input() flexibleHeight = false;
  @Input() transparentBackground = false;
  @Input() hasCustomEmptyContent = false;
  /** Opt-in for cards stretched to their row's height: the empty state fills the parent (a flex column) and centres vertically. */
  @Input() fillHeight = false;
  @Output() reload = new EventEmitter();
  @Output() clear = new EventEmitter();

  SectionState = SectionState;

  @HostBinding('class.state-section--fill-height') get fillsHeight(): boolean {
    return this.fillHeight && this.state === SectionState.Empty;
  }

  constructor(private comRef: ChangeDetectorRef) {}

  ngOnInit(): void {}

  onReload() {
    this.reload.emit(null);
  }

  ngAfterContentChecked() {
    this.comRef.detectChanges();
  }

  onClearButtonClicked(){
    this.clear.emit(null);
  }
}
